import React from "react";
import { Star, Globe } from "lucide-react";

const SOURCE_LABEL = {
  google: "Google", facebook: "Facebook", yelp: "Yelp",
  trustpilot: "Trustpilot", angi: "Angi", thumbtack: "Thumbtack",
  bbb: "BBB", web: "Web",
};

function Stars({ value }) {
  const v = Math.round(value || 0);
  return (
    <span className="inline-flex">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} className={`h-3.5 w-3.5 ${i <= v ? "fill-amber-500 text-amber-500" : "text-slate-300"}`} />
      ))}
    </span>
  );
}

/** Presentational list of imported external review sets (source badge + reviews). */
export default function WebReviews({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="space-y-6" data-testid="web-reviews">
      {items.map((set) => (
        <div key={set.id} className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`web-review-set-${set.source}`}>
          <div className="flex items-center gap-2 flex-wrap">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-[#165a71]/10 text-[#165a71] px-3 py-1 text-xs font-semibold">
              <Globe className="h-3.5 w-3.5" /> {SOURCE_LABEL[set.source] || set.source}
            </span>
            {set.overall_score != null && (
              <span className="inline-flex items-center gap-1 text-amber-600 font-semibold text-sm">
                <Star className="h-4 w-4 fill-amber-500 text-amber-500" /> {Number(set.overall_score).toFixed(1)}
              </span>
            )}
            {set.total_count != null && <span className="text-xs text-[#252A34]/60">{set.total_count} reviews</span>}
            {set.source_url && (
              <a href={set.source_url} target="_blank" rel="noreferrer" className="ml-auto text-xs text-[#165a71] hover:underline">
                View on {SOURCE_LABEL[set.source] || "site"}
              </a>
            )}
          </div>
          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            {(set.reviews || []).map((r, i) => (
              <div key={i} className="rounded-xl border border-slate-100 bg-slate-50/60 p-3">
                <div className="flex items-center justify-between gap-2">
                  <div translate="no" className="font-medium text-sm text-[#071b22] truncate">{r.author}</div>
                  {r.rating != null && <Stars value={r.rating} />}
                </div>
                {r.date && <div className="text-xs text-[#252A34]/60 mt-0.5">{r.date}</div>}
                <p translate="no" className="text-sm text-[#252A34]/85 mt-1.5 leading-relaxed">{r.text}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
